__turbopack_context__.v({
  "list": "UiNotice-module__rOLIiG__list",
  "notice": "UiNotice-module__rOLIiG__notice",
  "title": "UiNotice-module__rOLIiG__title",
});
